import 'react';
import { formatCurrency, formatNumber } from '@atc/string-fns';
import { Text, Link } from 'reaxl';
import { financingDisclaimers } from 'axl-config';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
const buildFinanceDisclaimer = (_ref, hasTax, contactDisclaimer, disclaimerKey, shortCustomDisclaimer, esntialHref) => {
  let {
    isPennyPerfectPayment,
    totalFinancing,
    localInterestRate,
    loanTerm,
    downPayment,
    totalInterest,
    lender,
    salePrice,
    payment
  } = _ref;
  const {
    financePrivateSellerDealDisclaimer,
    financePrivateSellerTaxesAndFeesDealDisclaimer,
    financeDealDisclaimer,
    financeTaxesAndFeesDealDisclaimer
  } = financingDisclaimers;
  let financeDisclaimerHasModal = false;
  let onPageFinanceDisclaimer = '';
  let modalText = '';
  let modalTitle = '';
  let modalTriggerText = '';
  const monthlyAPRCost = payment && totalFinancing ? Number(payment) / Number(totalFinancing) * 1000 : 0;
  const financingDetails = /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Text, {
      weight: "bold",
      children: ` ${formatCurrency(Math.floor(totalFinancing))} `
    }), "at", /*#__PURE__*/jsx(Text, {
      weight: "bold",
      children: ` ${formatNumber({
        value: localInterestRate
      })}`
    }), "% APR for", /*#__PURE__*/jsx(Text, {
      weight: "bold",
      children: ` ${formatNumber({
        value: loanTerm
      })} `
    })]
  });
  const creditApprovalDisclaimer = 'Actual terms may vary and are subject to credit approval.';
  switch (disclaimerKey) {
    case 'CoxAuto':
      // Esntial
      if (isPennyPerfectPayment) {
        onPageFinanceDisclaimer = /*#__PURE__*/jsxs(Fragment, {
          children: ["*Personalized monthly payment based on", financingDetails, " months with", /*#__PURE__*/jsx(Text, {
            weight: "bold",
            children: ` ${formatCurrency(Math.floor(downPayment))} `
          }), "down. Includes estimated tax, title, license, registration, and delivery fees (", /*#__PURE__*/jsx(Link, {
            className: "margin-horizontal-1",
            label: "see FAQs for details",
            target: "_blank",
            href: esntialHref && `${esntialHref.substring(0, esntialHref.indexOf('.com') + 4)}/esntial.htm#/faq`
          }), "). ", creditApprovalDisclaimer]
        });
      } else {
        onPageFinanceDisclaimer = /*#__PURE__*/jsxs(Fragment, {
          children: ["*Estimated monthly payment based on", financingDetails, " mos with", /*#__PURE__*/jsx(Text, {
            weight: "bold",
            children: ` ${formatCurrency(Math.floor(downPayment))} `
          }), "down, for illustrative purposes only.", ` ${hasTax ? 'Includes' : 'Excludes'}`, " estimated tax, title, document, license, registration, and delivery fees. ", creditApprovalDisclaimer]
        });
        modalText = `*Estimated monthly payment based on ${formatCurrency(Math.floor(totalFinancing))} at
                    ${formatNumber({
          value: localInterestRate
        })}% APR for ${formatNumber({
          value: loanTerm
        })} mos with
                    ${formatCurrency(Math.floor(downPayment))} down, for illustrative purposes only. ${hasTax ? 'Includes' : 'Excludes'} estimated tax, title,
                    document, license, registration, and delivery fees. Actual terms may vary and are subject to credit approval.
                    Total financing interest paid over ${formatNumber({
          value: loanTerm
        })} months is ${formatCurrency(Math.floor(totalInterest))}.`;
        modalTitle = 'Disclaimer';
        modalTriggerText = 'Read More';
        financeDisclaimerHasModal = true;
      }
      break;
    case 'PSX':
      onPageFinanceDisclaimer = /*#__PURE__*/jsxs(Fragment, {
        children: [hasTax ? financePrivateSellerTaxesAndFeesDealDisclaimer : financePrivateSellerDealDisclaimer, contactDisclaimer]
      });
      break;
    case 'BOA':
    case 'Accelerate':
      onPageFinanceDisclaimer = `*Estimated monthly payment based on advertised price of ${formatCurrency(Math.floor(salePrice))} at
                        ${formatNumber({
        value: localInterestRate
      })}% APR for ${formatNumber({
        value: loanTerm
      })}
                        months at ${monthlyAPRCost && formatCurrency(Math.floor(monthlyAPRCost) || 'N/A')}.00/month, per $1,000 financed,
                        ${formatCurrency(Math.floor(downPayment))} down for qualified buyers, ${formatCurrency(Math.floor(totalFinancing))}
                        total of all payments. ${hasTax ? 'Includes ' : 'Excludes '}
                        tax, title, registration, and license fees. Excludes leases and balloon contracts. Available at participating
                        dealers and is subject to credit approval by ${lender}. Offer may expire at any time without notification. See dealer for
                        details. Rate applies to vehicle shown. Not everyone will qualify.`;

      // Set up the modal if a short custom disclaimer is provided
      if (shortCustomDisclaimer) {
        modalText = onPageFinanceDisclaimer + ' ' + shortCustomDisclaimer;
        modalTitle = 'Disclaimer Details';
        modalTriggerText = 'See more details';
        financeDisclaimerHasModal = true;
      }
      break;
    default:
      onPageFinanceDisclaimer = hasTax ? financeTaxesAndFeesDealDisclaimer : financeDealDisclaimer;
      break;
  }
  return {
    financeDisclaimerHasModal,
    onPageFinanceDisclaimer,
    modalText,
    modalTitle,
    modalTriggerText
  };
};
export { buildFinanceDisclaimer as default };
